import { flip, offset, shift } from "@floating-ui/react";
import { useSideNav } from "lib/contexts/ProjectContexts/SideNavContext";
import HoverTooltip from "components/elements/Tooltips/HoverTooltip";

/** The side nav tooltip look without a line-wrapping rule: rounded, light text, even shadow. */
export const sideNavTooltipBaseClassName =
  "pointer-events-none z-50 motion-safe:animate-tooltipIn rounded-lg bg-white px-3 py-2 text-sm font-light text-gray-900 shadow-[0_0_2px_0_rgba(10,10,10,0.06),0_0_12px_0_rgba(10,10,10,0.10)]";

/** Shared look for side nav tooltips, kept on one line. */
export const sideNavTooltipClassName = `${sideNavTooltipBaseClassName} whitespace-nowrap`;

export default function SideNavTooltip(
  p: Readonly<{
    label: string;
    children: React.JSX.Element;
  }>,
) {
  const { isExpanded } = useSideNav();
  const isDisabled = !p.label || isExpanded;

  return (
    <HoverTooltip
      className="block w-full"
      placement="right"
      middleware={[offset({ mainAxis: 8, crossAxis: 0 }), flip(), shift()]}
      hoverOptions={{
        delay: { open: 800, close: 200 },
        move: false,
        enabled: !isDisabled,
      }}
      tooltipClassName={sideNavTooltipClassName}
      customTooltipContent={
        <>
          <div className="absolute -left-1 top-1/2 h-2 w-2 -translate-y-1/2 rotate-45 bg-white" />
          {p.label}
        </>
      }
    >
      {p.children}
    </HoverTooltip>
  );
}
